<template>
    <section 
        class="gz-data-row_small" 
        @click="$router.push(`/admin/address/${item.id}/schedule`)"
        style="cursor: pointer"
    >
        <GZ-TableDataCol slot="cols" class="gz-data__col_50px">
            <!-- Номер -->
            <div class="gz-col-inner">
                <span>{{ index }}</span>
            </div>
        </GZ-TableDataCol>        
        <GZ-TableDataCol slot="cols" class="gz-data__col_200px">
            <!-- Населенный пункт -->
            <div class="gz-col-inner">
                <span>{{data.city}}</span>
            </div>
        </GZ-TableDataCol>        
        <GZ-TableDataCol slot="cols" class="gz-data__col_200px">
            <!-- Адрес -->
            <div class="gz-col-inner">
                <span>{{ data.street }}</span>
            </div>
        </GZ-TableDataCol>        
        <GZ-TableDataCol slot="cols" class="gz-data__col_100px">
            <!-- Дом -->
            <div class="gz-col-inner">
                <span>{{ data.number }}</span>
            </div>
        </GZ-TableDataCol>        
        <GZ-TableDataCol slot="cols" class="gz-data__col_100px">
            <!-- Помещений -->
            <div class="gz-col-inner">
                <span></span>
            </div>
        </GZ-TableDataCol>        
        <GZ-TableDataCol slot="cols" class="gz-data__col_100px">
            <!-- Этажность -->
            <div class="gz-col-inner">
                <span>{{ data.levelNum }}</span>
            </div>
        </GZ-TableDataCol>           
        <GZ-TableDataCol slot="cols" class="gz-data__col_100">
                <!-- Календарь -->
                <Calendar :dates="data.checkupDates"/>
        </GZ-TableDataCol>        
    </section>
</template>

<script>
import Calendar from './Calendar'

export default {
    name: 'BaseStaffRow',

    components: {
        Calendar
    },
    props: {    
        item: {
            type: Object,
            default: () => ({})
        },
        index: Number
    },
    data() {
        return {
            data: this.item.attributes
        }
    }
}
</script>